import SignupForm from '../components/Auth/SignupForm';

function Signup() {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <SignupForm />
    </div>
  );
}

export default Signup;
